import { titleCase } from "title-case";

export const FormatString = (input) => {
  if (!input) return "";

  const words = input.trim().split(/\s+/);

  const initials = [];
  const lastNameParts = [];

  for (let i = 0; i < words.length; i++) {
    const word = words[i];

    if (word.length === 1 && lastNameParts.length === 0) {
      initials.push(word.toUpperCase() + ".");
    } else {
      lastNameParts.push(word.toLowerCase());
    }
  }

  const formattedLastName = titleCase(lastNameParts.join(" "));

  return [...initials, formattedLastName].join(" ");
};

export const formatNameToInitials = (input) => {
  if (!input) return "";

  const words = input.trim().split(/\s+/);
  const wordCount = words.length;

  if (wordCount <= 2) {
    return words.map(capitalize).join(" ");
  }

  const initials = words
    .slice(0, wordCount - 2)
    .map((word) => word.charAt(0).toUpperCase() + ".");

  const lastTwo = words.slice(wordCount - 2).map(capitalize);

  return [...initials, ...lastTwo].join(" ");
};

// Helper
const capitalize = (word) =>
  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
